import { render, staticRenderFns } from "./PenSvg.vue?vue&type=template&id=1d46cd43&"
import script from "./PenSvg.vue?vue&type=script&lang=js&"
export * from "./PenSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports